import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import { renderError } from "../../../helpers/errors";
import { createFilterQueryString } from "../../../helpers/helpers";
import { createModalProps, createOptions } from "../../../helpers/selects";
import api from "../../../services/api";
import InputSelect from "../../InputSelect";
import { ModalCreateCustomer } from "../../ModalCreateCustomer";

const SEARCH_DEBOUNCE_MS = 300;
const DEFAULT_RESULTS_PER_PAGE = 30;
const MIN_SEARCH = 1;

export const SelectCustomer = ({
    selectedCustomer,
    setSelectedCustomer,
    companyId,
    relatedWithCompany,
    setCustomerData,
    perPage = DEFAULT_RESULTS_PER_PAGE,
    create,
}) => {
    const [customers, setCustomers] = useState([]);
    const [search, setSearch] = useState('');
    const [noOptionsText, setNoOptionsText] = useState(null);
    const [showCreate, setShowCreate] = useState(false);
    const debounceRef = useRef(null);

    useEffect(() => {
        if (debounceRef.current) clearTimeout(debounceRef.current);
        if (relatedWithCompany && companyId === null) {
            setNoOptionsText('Primeiro, escolha a empresa...');
            setCustomers([]);
            if (window.cancelToken) window.cancelToken.cancel();
            return;
        }
        if (relatedWithCompany && companyId !== null) {
            getCustomers();
            return;
        }
        if (search.length < MIN_SEARCH) {
            setNoOptionsText(`Digite ao menos ${MIN_SEARCH} caracter${MIN_SEARCH > 1 ? 'es' : ''}...`);
            setCustomers([]);
            if (window.cancelToken) window.cancelToken.cancel();
            return;
        }
        debounceRef.current = setTimeout(() => getCustomers(), SEARCH_DEBOUNCE_MS);
        return () => {
            if (debounceRef.current) clearTimeout(debounceRef.current);
        };
    }, [search, companyId, relatedWithCompany]);

    useEffect(() => {
        getSelectedCustomer();
    }, [selectedCustomer]);

    const getSelectedCustomer = () => {
        if(selectedCustomer === null) return;
        api.get(`/customer/${selectedCustomer}`).then(res => {
            setCustomers([res.data.resource]);
            if(setCustomerData){
                setCustomerData(res.data.resource);
            }
        });
    }

    const getCustomers = () => {
        setCustomers([]);
        setNoOptionsText('Carregando...');
        if (typeof window.cancelToken !== 'undefined' && window.cancelToken) {
            window.cancelToken.cancel();
        }
        window.cancelToken = axios.CancelToken.source();

        let arrayFilters = [];
        if (companyId !== null && companyId !== undefined) {
            arrayFilters = [`[related][companies.id][equal]=${companyId}`];
        } else {
            arrayFilters = [
                [`[code][equal]=${search}`],
                [`[name][contain]=${search}`]
            ];
        }

        const stringFilters = createFilterQueryString(arrayFilters);
        const limitParam = `per_page=${perPage}`;
        const url = `/customer?${stringFilters}${limitParam}`;

        api.get(url, {
            cancelToken: window.cancelToken.token
        }).then(res => {
            const raw = res.data?.resources?.data ?? res.data?.resources ?? res.data?.data;
            const list = Array.isArray(raw) ? raw : [];
            setCustomers(list);
            setNoOptionsText(list.length === 0 ? 'Nenhum resultado encontrado' : null);
            if (relatedWithCompany && companyId != null && list.length === 1 && list[0]?.id) {
                setSelectedCustomer(list[0].id);
            }
        }).catch(error => {
            if (error.code !== undefined) renderError(error);
            setNoOptionsText('Erro ao carregar. Tente novamente.');
        });
    }

    return (
        <>
            {create &&
                <ModalCreateCustomer
                    companies={companyId ? [companyId] : null}
                    hideCompany={true}
                    {...createModalProps(create)}
                    show={showCreate}
                    close={() => setShowCreate(false)}
                    customerStored={customer => {
                        setShowCreate(false);
                        setSelectedCustomer(customer.id);
                    }}
                    showSuccess={false}
                />
            }
            <InputSelect
                noOptionsText={noOptionsText}
                label={`Pessoa`}
                options={createOptions(customers, ['code', 'name'], 'id')} 
                value={selectedCustomer} 
                change={setSelectedCustomer}
                setSearch={value => setSearch(value)}
                onCreate={create ? () => setShowCreate(true) : undefined}
            />
        </>
    );
}

export default SelectCustomer;